import can from 'can';
import Component from 'can/component/component';
import template from './modal-backdrop.stache';

const viewModel = can.Map.extend({
    define: {
        isVisible: {
            type: 'boolean',
            value: false,
        },
    },
});

Component.extend({
    viewModel: viewModel,
    template: template,
    leakScope: false,
    tag: 'modal-backdrop',
    events: {
        '.js-backdrop click': function() {
            this.viewModel.dispatch('clicked');
            this.viewModel.attr('isVisible', false);
        },
    },
});
